import { TColors } from '@cian/ui-kit-design-tokens/colors';
import { IconFunctionalHouse16 } from '@cian/ui-kit-design-tokens/icons';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import * as styles from './BuildingIcon.css';

interface IBuildingIconProps {
  isActive?: boolean;
  isViewed?: boolean;
}

export const BuildingIcon = ({ isActive, isViewed }: IBuildingIconProps): ReactNode => {
  let color: TColors = isViewed ? 'icon-inverted-disabled' : 'icon-inverted-default';
  if (isActive) {
    color = 'icon-positive-default';
  }

  return (
    <div className={clsx(styles['building-icon'], isActive && styles['active'], isViewed && styles['viewed'])}>
      <IconFunctionalHouse16 color={color} />
    </div>
  );
};

export const getBuildingIcon = (props: IBuildingIconProps) => renderToStaticMarkup(<BuildingIcon {...props} />);
